export const SHADOW_LIGHT = '0px 4px 10px rgba(0, 0, 0, 0.15)';
